import { render, staticRenderFns } from "./card-grid-boxer.vue?vue&type=template&id=71a5bec6&scoped=true&"
import script from "./card-grid-boxer.vue?vue&type=script&lang=js&"
export * from "./card-grid-boxer.vue?vue&type=script&lang=js&"
import style0 from "./card-grid-boxer.vue?vue&type=style&index=0&id=71a5bec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a5bec6",
  null
  
)

export default component.exports